import React, { useEffect, useMemo } from "react";
import { useMap } from "react-map-gl";
import { useMapboxDraw } from "../DrawToolProvider";
import { HandleFeatureCreation, HandleFeatureIdentity, HandleFeatureUpdate, HandleFeatureClick, HandleFeatureDelete, HandleFeatureHover } from ".";
import { MapboxOffset } from "../MapboxOffset";
import { useSelector } from "react-redux";

const MapboxFeatureHandler = () => {
  const site_features = useSelector((state) => state.inputs.site_features);
  const memoizedFeatures = useMemo(() => site_features, [site_features]);

  // const loading = useSelector((state) => state.projects.loading);
  // const loaded = useSelector((state) => state.projects.loaded);

  // const just_loaded = loading === false && prev_loading === true;

  // useEffect(() => {
  //   console.log(" cur", loaded, loading);
  //   console.log("prev", prev_loaded, prev_loading);
  //   console.log("just", just_loaded);
  // }, [loaded, loading]);

  return (
    <>
      <HandleFeatureCreation />
      {Object.values(memoizedFeatures).map((feature) => (
        <GeoJsonFeature key={feature.properties.index} feature={feature} />
      ))}
    </>
  );
};

const GeoJsonFeature = ({ feature }) => {
  const { current: mapRef } = useMap();
  const map = mapRef.getMap();
  const draw = useMapboxDraw();
  const selectedFeatureId = useSelector((state) => state.inputs.selectedFeatureId);
  const memoizedFeature = useMemo(() => feature, [feature]);

  useEffect(() => {
    if (!map || !draw || !memoizedFeature) return;
    // console.log("the memorized feature:", memoizedFeature);
    const memoizedFeatureWithId = {
      ...memoizedFeature,
      id: memoizedFeature.properties.index, // add our custom id so that we can delete/highlight etc.
      properties: {
        ...memoizedFeature?.properties,
        shape: "siteFeature",
      },
    };

    draw.add(memoizedFeatureWithId);

    map.once("idle", () => {
      selectFeatureOnMap(selectedFeatureId);
    });

    return () => {
      draw.delete(memoizedFeature.properties.index);
    };
  }, [map, memoizedFeature, memoizedFeature.properties.identity]);

  const selectFeatureOnMap = (id) => {
    draw.changeMode("simple_select", { featureIds: id });
  };

  return (
    <>
      <HandleFeatureClick feature={feature} />
      <HandleFeatureUpdate feature={feature} />
      <HandleFeatureIdentity feature={feature} />
      <HandleFeatureDelete feature={feature} />
      <HandleFeatureHover feature={feature} />
      {selectedFeatureId && feature.properties.index && <MapboxOffset feature_id={feature.properties.index} />}
    </>
  );
};

export { MapboxFeatureHandler, GeoJsonFeature };
